import { render } from "./ArgonAlert.vue?vue&type=template&id=2b4eb988"
import script from "./ArgonAlert.vue?vue&type=script&lang=js"
export * from "./ArgonAlert.vue?vue&type=script&lang=js"
script.render = render

export default script